import { useContext } from 'react';

import VacanciesContext from './vacancies.context';

function useVacancies() {
  const context = useContext(VacanciesContext);

  if (!context) {
    throw new Error('useVacancies must be used within VacanciesContext');
  }

  return context;
}

export default useVacancies;